import { useEffect } from 'react';
import { useRouter } from 'next/router';
import { withAuth } from 'features/auth/withAuth';

export const tabItems = [
  {
    label: 'My Plan',
    path: '/my-account/billing/plan',
  },
  {
    label: 'Billing History',
    path: '/my-account/billing/history',
  },
  {
    label: 'Credit Card Details',
    path: '/my-account/billing/update-card',
  },
  {
    label: 'Available Plans',
    path: '/my-account/billing/available-plans',
  },
];

function Profile() {
  const router = useRouter();

  useEffect(() => {
    router.push('/my-account/billing/plan');
  }, []);

  return null;
}

export default withAuth(Profile);
